import { render, staticRenderFns } from "./VuseSectionDefinition.vue?vue&type=template&id=400c501b&scoped=true&"
import script from "./VuseSectionDefinition.vue?vue&type=script&lang=js&"
export * from "./VuseSectionDefinition.vue?vue&type=script&lang=js&"
import style0 from "./VuseSectionDefinition.vue?vue&type=style&index=0&id=400c501b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c501b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VBreadcrumbs,VContainer,VIcon,VSpacer,VToolbar,VToolbarTitle})
